import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

/* import function from store folder */
import { resetModel } from '../../store/components/modelSlice';

/* import fetch function */
import { SendEmail } from "../../services/forget";

const ForgetModel = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    const [sended, setSend] = useState(false);

    const cancelHandler = () => dispatch(resetModel());

    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);

        delete error[name];

        _source[name] = value;
        
        setError(error);
        setSource(_source);
    };

    const submitHandler = (e) => {
        const isValidate = validate();
        
        if (!isValidate) return;
        
        SendEmail(source).then(response => {
            if (!Object.keys(response).length) {
                setSend(true);
            }
        });
    };

    const validate = () => {
        const regex = {
            email: /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
        };
        const checkLists = ['email'];
        const _errors = {};

        checkLists.map( list => {
            const input = document.querySelector(`[name=${list}]`);

            if (!source[list])
                _errors[list] = true;
            else if (!regex[list]?.test(source[list])) {
                _errors[list] = true;

                input.setCustomValidity('The email you entered does not conform to the format');
            }

            input.reportValidity();
        });
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    return (
        <Modal show={ true } centered>
            <Modal.Header>Send reset link</Modal.Header>
            <Modal.Body>
                <div className="subject-container">
                    <Form.Control type='email' name='email' placeholder='Please enter your email' is-required={`${error.email}`} hidden={ sended } onChange={ changHandler } />
                    <span hidden={ !sended }>A reset password link has been sent to your email, please click the link to set your password!</span>
                </div>
                <div className="button-container">
                    <Button type="button" data-shadow onClick={ cancelHandler }>{ !sended ? 'Cancel' : 'Confirm' }</Button>
                    <Button type="button" data-shadow hidden={ sended } onClick={ submitHandler }>Submit</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ForgetModel;